const React = require('react')
const { useHistory } = require('react-router-dom')
const { LoadingSpinner } = require('@components')
const { useNetworkConfig } = require('@contexts')

require('@styles/pages/address/statistics.address.css')

const TokenInfo = props => {
    const { loading, data } = props
    const history = useHistory()
    const { network } = useNetworkConfig()

    return (
        <div className='box table-section'>
            {loading ? (
                <div className='d-flex justify-content-center align-items-center' style={{ height: '300px' }}>
                    <LoadingSpinner />
                </div>
            ) : (
                <>
                    {data?.metadata.description ? (
                        <>
                            <div style={{ fontWeight: 'bold', fontSize: '20px' }}>Overview</div>
                            <div style={{ fontSize: '14px', paddingTop: '8px' }}>{data?.metadata.description}</div>
                        </>
                    ) : (
                        <>
                            <div style={{ fontSize: '14px', paddingTop: '8px' }}>
                                Click here to&nbsp;
                                <span
                                    className={`${network.name}-text-color cursor-pointer`}
                                    onClick={() => {
                                        history.push(`/${network.name}/tokenupdate`)
                                    }}
                                >
                                    update
                                </span>
                                &nbsp;the token information / general information
                            </div>
                        </>
                    )}
                </>
            )}
        </div>
    )
}

module.exports = { TokenInfo }
